import { apiConf as api } from 'commons'

export const fetchOrganisation = (uuid, usrId, uorIdMst, landId) => {
  return api.superFetch({
    url: `organisation?usrid=${usrId}&uoridmst=${uorIdMst}&lanId=${landId}`,
    uuid: uuid,
  })
}
